import {
  LOADING_INICIATIVAS_IA,
  LOAD_INICIATIVAS_IA,
  ERROR_INICIATIVAS_IA,
  LOADING_INICIATIVAS_IA_CATALOGOS,
  LOAD_INICIATIVAS_IA_CATALOGOS,
  ERROR_INICIATIVAS_IA_CATALOGOS,
  LOADING_INICIATIVAS_IA_KPI,
  LOAD_INICIATIVAS_IA_KPI,
  ERROR_INICIATIVAS_IA_KPI,
  LOADING_INICIATIVAS_IA_CHAMPIONS,
  LOAD_INICIATIVAS_IA_CHAMPIONS,
  ERROR_INICIATIVAS_IA_CHAMPIONS,
} from "./iniciativasIATypes";
import { IniciativasIAServices } from "../../services/iniciativasIA";

// Thunks del módulo "Iniciativas de IA" (spec 008, Incremento 1: Registro, plan.md §3.3). Molde de fetch
// simple: redux/retroBoard/retroBoardActions.js (LOADING_X/LOAD_X/ERROR_X). Los thunks de escritura
// (crear/editar/borrar) devuelven la promesa del service para que el componente encadene el swal de
// confirmación y lea el `code` de negocio con getIniciativaErrorCode (services/iniciativasIA.js), y
// refrescan el listado completo tras cada escritura — sin update optimista: el volumen es bajo (P15/CA-24
// no depende de esto) y así el listado queda consistente con el `Codigo`/`Estado` que devolvió el SP.

export const fetchIniciativas = () => (dispatch) => {
  dispatch({ type: LOADING_INICIATIVAS_IA });
  return IniciativasIAServices.listIniciativas()
    .then((data) => dispatch({ type: LOAD_INICIATIVAS_IA, payload: data }))
    .catch(() => dispatch({ type: ERROR_INICIATIVAS_IA }));
};

export const fetchCatalogos = () => (dispatch) => {
  dispatch({ type: LOADING_INICIATIVAS_IA_CATALOGOS });
  return IniciativasIAServices.getCatalogos()
    .then((data) => dispatch({ type: LOAD_INICIATIVAS_IA_CATALOGOS, payload: data }))
    .catch(() => dispatch({ type: ERROR_INICIATIVAS_IA_CATALOGOS }));
};

export const fetchKpi = () => (dispatch) => {
  dispatch({ type: LOADING_INICIATIVAS_IA_KPI });
  return IniciativasIAServices.getKpi()
    .then((data) => dispatch({ type: LOAD_INICIATIVAS_IA_KPI, payload: data }))
    .catch(() => dispatch({ type: ERROR_INICIATIVAS_IA_KPI }));
};

export const createIniciativa = (payload) => (dispatch) =>
  IniciativasIAServices.createIniciativa(payload).then((data) => {
    dispatch(fetchIniciativas());
    return data;
  });

export const updateIniciativa = (id, payload) => (dispatch) =>
  IniciativasIAServices.updateIniciativa(id, payload).then((data) => {
    dispatch(fetchIniciativas());
    return data;
  });

export const deleteIniciativa = (id) => (dispatch) =>
  IniciativasIAServices.deleteIniciativa(id).then((data) => {
    dispatch(fetchIniciativas());
    return data;
  });

// Incrementos 2-3 (plan.md §14.2). `fetchChampions` no bloquea la UI general (mismo criterio que
// `fetchKpi`: es una consulta independiente que alimenta el gating de las 2 pestañas del Champion y el
// desplegable "¿A qué Champion se envía?", no debe tapar el listado con el Loader genérico).
export const fetchChampions = () => (dispatch) => {
  dispatch({ type: LOADING_INICIATIVAS_IA_CHAMPIONS });
  return IniciativasIAServices.getChampions()
    .then((data) => dispatch({ type: LOAD_INICIATIVAS_IA_CHAMPIONS, payload: data }))
    .catch(() => dispatch({ type: ERROR_INICIATIVAS_IA_CHAMPIONS }));
};

// cambiarEstadoIniciativa/habilitarIniciativa siguen el mismo patrón de escritura que
// createIniciativa/updateIniciativa/deleteIniciativa: devuelven la promesa del service (para que el
// componente encadene el swal de confirmación/error con getIniciativaErrorCode) y refrescan el listado
// completo tras la escritura, para que las 3 pestañas (filtradas client-side sobre el mismo listado, P21)
// reflejen el nuevo estado sin una llamada a un SP nuevo.
export const cambiarEstadoIniciativa = (id, payload) => (dispatch) =>
  IniciativasIAServices.cambiarEstado(id, payload).then((data) => {
    dispatch(fetchIniciativas());
    return data;
  });

export const habilitarIniciativa = (id, payload) => (dispatch) =>
  IniciativasIAServices.habilitar(id, payload).then((data) => {
    dispatch(fetchIniciativas());
    return data;
  });
